.section {
    margin-bottom: 24px;
}

.switchRow {
    display: flex;
    align-items: center;
    gap: 4px;
}
